import React, { ReactElement } from "react";
import styled, { keyframes } from "styled-components";

const GradientKeyframes = keyframes`
    0% {
        background-position: 0% 0%;
    }
    100% {
        background-position: 100% 100%;
    }
`;

export const AnimatedGradientDiv = styled.div`
    animation: ${GradientKeyframes} 10s ease infinite;
    min-height: 100vh;
    background: linear-gradient(90deg, rgba(253, 138, 138, 0.1), rgba(168, 209, 170, 0.1), rgba(0, 212, 255, 0.1), rgba(253, 138, 138, 0.1), rgba(168, 209, 170, 0.1));
    background-size: 400% 400%;
`;

export const AnimatedGradient = ({ disabled, children }: { disabled?: boolean; children: any }) => {
    if (disabled) {
        return <>{...children}</>;
    }
    return <AnimatedGradientDiv>{...children}</AnimatedGradientDiv>;
};
